module.exports = __webpack_public_path__ + "static/media/anglicka-vlajka-union-jack-i135.b727309c.svg";